import React, { useState } from 'react';
import withPageWrapper from '../../components/Shared/HOCs/withPageWrapper';
import FilterSection from '../../components/CategoryPages/SingForFun/Sections/FilterSection';
import Header from '../../components/CategoryPages/SingForFun/Sections/Header';
import MainSection from '../../components/CategoryPages/SingForFun/Sections/MainSection/Index';
import useGetResources from '../../hooks/Resource/useGetResources';
import useGetSongs from '../../hooks/Song/useGetSongs';
import { returnHasTags } from '../../utils/helpers';
import { updateQuery } from '../../utils/objects';
import { buildResourceParams } from '../../utils/resource';
import useGetPlaylists from '../../hooks/Playlist/useGetPlaylists';

const SingForFun = () => {
  const [displaySongs, setDisplaySongs] = useState(true);
  const [displayResources, setDisplayResources] = useState(true);
  const [displayPlaylists, setDisplayPlaylists] = useState(true);
  const [filterParams, setFilterParams] = useState({});

  const {
    data: resources,
    loading: loadingResources,
    fetchMore: fetchMoreResources,
  } = useGetResources(
    2,
    returnHasTags('hasTags', 'OOTA Singing School', 'Just for Fun')
  );

  const {
    data: songs,
    loading: loadingSongs,
    fetchMore: fetchMoreSongs,
  } = useGetSongs(
    6,
    returnHasTags('hasSongTags', 'OOTA Singing School', 'Just for Fun', true),
    true
  );

  const { data: playlists, fetchMore: fetchMorePlaylists } = useGetPlaylists(
    'sy',
    {
      hasCategoryPages: { column: 'NAME', value: 'sing for fun' },
    }
  );

  const handleFilter = (params) => {
    const resourceParams = buildResourceParams(params);

    fetchMoreSongs({
      variables: { ...params },
      ...updateQuery,
    });
    fetchMoreResources({
      variables: { ...resourceParams },
      ...updateQuery,
    });
    fetchMorePlaylists({
      variables: { ...params },
      ...updateQuery,
    });
    setDisplaySongs(true);
    setDisplayResources(true);
    setDisplayPlaylists(true);
    setFilterParams(params);
  };

  const loading = loadingResources || loadingSongs;

  return (
    <>
      <Header />
      <FilterSection loading={loading} handleFilter={handleFilter} />
      <MainSection
        songs={songs?.songs?.data}
        resources={resources?.resources?.data}
        displayResources={displayResources}
        displaySongs={displaySongs}
        displayPlaylists={displayPlaylists}
        playlists={playlists?.playlists}
        filterParams={filterParams}
      />
    </>
  );
};

export default withPageWrapper({})(SingForFun);
